import { c as _c } from "react/compiler-runtime";
import { Loading03Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
function Spinner() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { Spinner };